<app-loading-screen [StartUp]="(combinedLoaders$ | async)"
   *ngIf="!statusResolved || (componentUrl != STEPS.InitialAssessment && componentUrl != STEPS.AssignTarget && !isNewDigLit)">
</app-loading-screen>


<app-initial-assessment *ngIf="statusResolved && componentUrl == STEPS.InitialAssessment && !isNewDigLit" [courseId]="courseId"
[learnerCourseLogId]="lcLogId" [learnerId]="learnerId"></app-initial-assessment>

<app-assign-target *ngIf="statusResolved && componentUrl == STEPS.AssignTarget && !isNewDigLit"
 [courseId]="courseId"
 [lcLogId]="lcLogId"
 [learnerId]="learnerId">
</app-assign-target>

<app-digital-lit-self-assessment *ngIf="statusResolved && isNewDigLit && componentUrl == STEPS.InitialAssessment"
   [courseIconPath]="courseIconPath"
   [learnerId]="learnerId"></app-digital-lit-self-assessment>